/** Normaliza Nota 1 (uso interno) del maestro de proveedores. */
export const normalizarNotasProveedor = (notas?: string | null): string =>
  String(notas ?? '').replace(/\s+/g, ' ').trim();

/** Nota 2 (uso bancario / público), conservando saltos de línea. */
export const textoNotasPublicasProveedor = (notas2?: string | null): string =>
  String(notas2 ?? '').replace(/\r\n/g, '\n').trim();
